import serviceClient from '../../service-client/service-client';

const deleteSiteBackup = (backupId) => () => {
  const apiClient = serviceClient.get();
  return apiClient.deleteSiteBackup(backupId);
};

export default deleteSiteBackup;
